import * as React from 'react';
import { useState } from 'react';
import { PresetValidationResult } from '@canvas-logic/clp-api-types';
import styles from './PresetValidationBanner.module.css';

interface PresetValidationBannerProps {
  validation: PresetValidationResult;
}

// TODO: Replace hardcoded strings with i18n translations once configurator i18n keys are defined
function PresetValidationBanner({ validation }: PresetValidationBannerProps) {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed || !validation.errors.length) {
    return null;
  }

  const isError = validation.validationStatus === 'invalid';
  const bannerClass = isError ? styles['banner--error'] : styles['banner--warning'];

  return (
    <div className={`${styles.banner} ${bannerClass}`}>
      <div className={styles.bannerContent}>
        <div className={styles.bannerTitle}>
          {isError ? 'Preset Configuration Error' : 'Preset Configuration Warning'}
        </div>
        <ul className={styles.bannerMessages}>
          {validation.errors.map((error, index) => (
            <li key={index}>{error.message}</li>
          ))}
        </ul>
      </div>
      <button className={styles.dismissButton} onClick={() => setDismissed(true)} aria-label="Dismiss">
        &times;
      </button>
    </div>
  );
}

export default PresetValidationBanner;
